import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ProcessMapLaneDimensionSchema } from '../../shared/process-map.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const ProcessMapPositionItemSchema = z.object({
    processId: ObjectIdSchema,
    x: z.number(),
    y: z.number()
});
export const UpdateProcessMapPositionsRequestSchema = z.object({
    positions: z.array(ProcessMapPositionItemSchema).max(500),
    laneDimensions: z.array(ProcessMapLaneDimensionSchema).max(50).optional()
});
export const UpdateProcessMapPositionsResponseSchema = z.object({
    updated: z.number()
});
export const ResetProcessMapPositionsResponseSchema = z.object({
    deleted: z.number()
});

//# sourceMappingURL=update-process-map-positions.schema.js.map